import classNames from 'classnames';

import { InterviewReviewTabs } from '~hooks/query/review/useGetInterview';
import { InterviewReviewType } from '~types/review';

import * as S from './style';

interface Props {
  tabs: InterviewReviewTabs[];
  activeMenu?: InterviewReviewType;
  onClick?: (tabId: InterviewReviewType) => void;
}

export default function Tabs({ tabs, activeMenu, onClick }: Props) {
  const handleClick = (tabId: InterviewReviewType) => {
    if (onClick) {
      onClick(tabId);
    }
  };

  const getIsSelected = (tabId: InterviewReviewType, index: number) => {
    if (!activeMenu && index === 0) {
      return true;
    }

    return tabId === activeMenu;
  };

  if (!tabs) {
    return null;
  }

  return (
    <S.TabsWrapper role='tablist'>
      {tabs?.map((item, index) => (
        <S.TabItem
          role='tab'
          id={item.id}
          key={item.id}
          className={classNames({ active: getIsSelected(item.id, index) })}
          onClick={() => handleClick(item.id)}>
          <S.TabItemAnchor>{item.content}</S.TabItemAnchor>
        </S.TabItem>
      ))}
    </S.TabsWrapper>
  );
}
